/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import { Typography, Box } from '@material-ui/core';
import { MediaType } from 'models/forms';
import { MediaFile } from 'models';
import useStyles from './style';

interface Props {
  id?: string;
  buttonText: string;
  mediaType: MediaType;
  file: MediaFile;
  onChange: (file: MediaFile) => void;
}

const MediaUploader: React.FC<Props> = (props) => {
  const { id, buttonText, mediaType, file, onChange } = props;
  const classes = useStyles();
  const fileFormat = `${mediaType.toString()}/*`;

  const handleUpload = ({ target }: any): void => {
    onChange({ name: target.files[0].name, file: target.files[0] });
  };

  return (
    <div>
      <input
        type='file'
        accept={fileFormat}
        id={id || 'upload-video-button'}
        className={classes.input}
        onChange={handleUpload}
      />
      <label htmlFor={id || 'upload-video-button'}>
        {!file.file && (
          <div className={classes.container}>
            <Typography variant='body2' className={classes.title}>
              {buttonText}
            </Typography>
          </div>
        )}
        {file.file && (
          <Box className={classes.container}>
            <Typography variant='body1' className={classes.fileName}>
              {file.name}
            </Typography>
          </Box>
        )}
      </label>
    </div>
  );
};

export default MediaUploader;
